import axiosUtil from "../utils/axiosUtil"

const ticketsApi = {
    getTickets: async ({perPage, page}) => {
        try {
            const result = await axiosUtil.get('/tickets', {
                perPage: (!perPage || perPage <= 0) ? 10 : perPage,
                page: (!page || page <= 0) ? 1 : page,
            })
            return result;
        } catch (error) {
        }
    },
    getTicketById: async (ticketId) => {
        try {
            const result = await axiosUtil.get(`/tickets/${ticketId}`)
            return result;
        } catch (error) {
            console.error(error);
        }
    },
    createTicket: async (body) => {
        try {
            const result = await axiosUtil.post('/tickets', body, {'Content-Type': "multipart/form-data"})
            return result;
        } catch (error) {
            console.error(error);
        }
    },
    createComment: async ({ body, ticketId }) => {
        try {
            const result = await axiosUtil.put(`/tickets/comment/${ticketId}`, body, {'Content-Type': "multipart/form-data"})
            return result;
        } catch (error) {
            console.error(error);
        }
    }
}

export default ticketsApi;
